var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A8A19B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.832 6.169L2.008.345c-.46-.46-1.204-.46-1.663 0-.46.459-.46 1.204 0 1.663L5.336 7 .345 11.992c-.46.46-.46 1.204 0 1.663.459.46 1.204.46 1.663 0l5.824-5.824c.46-.458.46-1.203 0-1.662z",
    transform: "translate(-289 -82) translate(289 82)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemArrowRight);
export default __webpack_public_path__ + "static/media/systemArrowRight.0311da9c.svg";
export { ForwardRef as ReactComponent };